import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import 'simplebar/dist/simplebar.min.css';
import SimpleBar from 'simplebar-react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {NavLink} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {isCamAPSLibertyVisible} from '../utils/countries';

import phone_image from '../assets/images/phone-hero-image.png';
import phone_image_fr_ca from '../assets/images/phone-hero-image-fr-ca.png';
import service_ic from '../assets/images/adaptable-ic.svg';
import smartphone_ic from '../assets/images/android-ic.svg';
import family_ic from '../assets/images/family-ic.svg';
import tested_ic from '../assets/images/tested-ic.svg';
import file_ic from '../assets/images/file-ic.svg';
import down_arrow from '../assets/images/download-arrow.png';
import liberty_home_bg from '../assets/images/liberty-home-segment-bg.png';
import liberty_logo_white from '../assets/images/camaps-liberty-logo-white.png';
import pregnancy_home_bg from '../assets/images/pregnancy-home-segment-bg.png';
import article_img01 from '../assets/images/article-sam-and-sofia-steve.jpg';
import article_img02 from '../assets/images/article-roger.jpg';
import article_img03 from '../assets/images/article-amanda-mclaren.jpg';
import article_img04 from '../assets/images/article-christopher-salter.jpg';
import article_img05 from '../assets/images/article-alice-hibbert-davies.jpg';
import {samReviewText as samReviewText_en} from "../libs/en/texts-review-messages-lib";
import {samReviewText as samReviewText_de} from "../libs/de/texts-review-messages-lib";
import {samReviewText as samReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {samReviewText as samReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {samReviewText as samReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {samReviewText as samReviewText_it} from "../libs/it/texts-review-messages-lib";
import {samReviewText as samReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {samReviewText as samReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {samReviewText as samReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {samReviewText as samReviewText_se} from "../libs/se/texts-review-messages-lib";
import {samReviewText as samReviewText_no} from "../libs/no/texts-review-messages-lib";
import {samReviewText as samReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {samReviewText as samReviewText_es} from "../libs/es/texts-review-messages-lib";
import {samReviewText as samReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_en} from "../libs/en/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_de} from "../libs/de/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_it} from "../libs/it/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_se} from "../libs/se/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_no} from "../libs/no/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_es} from "../libs/es/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_en} from "../libs/en/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_de} from "../libs/de/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_it} from "../libs/it/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_se} from "../libs/se/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_no} from "../libs/no/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_es} from "../libs/es/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_en} from "../libs/en/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_en} from "../libs/en/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_de} from "../libs/de/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_de} from "../libs/de/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_it} from "../libs/it/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_it} from "../libs/it/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_se} from "../libs/se/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_se} from "../libs/se/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_no} from "../libs/no/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_no} from "../libs/no/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_es} from "../libs/es/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_es} from "../libs/es/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {homePageText as homePageText_en} from "../libs/en/texts-home-page-lib";
import {homePageText as homePageText_en_ca} from "../libs/en-ca/texts-home-page-lib";
import {homePageText as homePageText_de} from "../libs/de/texts-home-page-lib";
import {homePageText as homePageText_fr} from "../libs/fr/texts-home-page-lib"
import {homePageText as homePageText_fr_ca} from "../libs/fr-ca/texts-home-page-lib"
import {homePageText as homePageText_nl} from "../libs/nl/texts-home-page-lib"
import {homePageText as homePageText_it} from "../libs/it/texts-home-page-lib"
import {homePageText as homePageText_cz} from "../libs/cz/texts-home-page-lib"
import {homePageText as homePageText_fi} from "../libs/fi/texts-home-page-lib"
import {homePageText as homePageText_pl} from "../libs/pl/texts-home-page-lib"
import {homePageText as homePageText_se} from "../libs/se/texts-home-page-lib"
import {homePageText as homePageText_no} from "../libs/no/texts-home-page-lib"
import {homePageText as homePageText_dk} from "../libs/dk/texts-home-page-lib"
import {homePageText as homePageText_es} from "../libs/es/texts-home-page-lib"
import {homePageText as homePageText_pt} from "../libs/pt/texts-home-page-lib"
import {userReviewsIntro as userReviewsIntro_en} from "../libs/en/common-text-lib";
import {userReviewsIntro as userReviewsIntro_en_ca} from "../libs/en-ca/common-text-lib";
import {userReviewsIntro as userReviewsIntro_de} from "../libs/de/common-text-lib";
import {userReviewsIntro as userReviewsIntro_fr} from "../libs/fr/common-text-lib";
import {userReviewsIntro as userReviewsIntro_fr_ca} from "../libs/fr-ca/common-text-lib";
import {userReviewsIntro as userReviewsIntro_nl} from "../libs/nl/common-text-lib";
import {userReviewsIntro as userReviewsIntro_it} from "../libs/it/common-text-lib";
import {samReviewText as samReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {samReviewText as samReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {homePageText as homePageText_de_ch} from "../libs/de-ch/texts-home-page-lib";
import {homePageText as homePageText_it_ch} from "../libs/it-ch/texts-home-page-lib";
import {userReviewsIntro as userReviewsIntro_de_ch} from "../libs/de-ch/common-text-lib";
import {userReviewsIntro as userReviewsIntro_it_ch} from "../libs/it-ch/common-text-lib";
import {userReviewsIntro as userReviewsIntro_cz} from "../libs/cz/common-text-lib";
import {userReviewsIntro as userReviewsIntro_fi} from "../libs/fi/common-text-lib";
import {userReviewsIntro as userReviewsIntro_pl} from "../libs/pl/common-text-lib";
import {userReviewsIntro as userReviewsIntro_se} from "../libs/se/common-text-lib";
import {userReviewsIntro as userReviewsIntro_no} from "../libs/no/common-text-lib";
import {userReviewsIntro as userReviewsIntro_dk} from "../libs/dk/common-text-lib";
import {userReviewsIntro as userReviewsIntro_es} from "../libs/es/common-text-lib";
import {userReviewsIntro as userReviewsIntro_pt} from "../libs/pt/common-text-lib";
import parse from "html-react-parser";
import popup_img from '../assets/images/popup-img.jpg';
import video_ic from '../assets/images/video-ic.png';
// import ReactGA from "react-ga4";

export class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            samReviewText: samReviewText_en,
            rogerReviewText: rogerReviewText_en,
            amandaReviewText: amandaReviewText_en,
            christopherReviewText: christopherReviewText_en,
            aliceReviewText: aliceReviewText_en,
            userReviewsIntro: userReviewsIntro_en,
            homePageText: homePageText_en,
            isOpen: null,
            isIOS: true,
            prefix: '',
            currentSlide: 0,
        };
        if (this.props.language === "DE") {
            this.state.samReviewText = samReviewText_de;
            this.state.rogerReviewText = rogerReviewText_de;
            this.state.amandaReviewText = amandaReviewText_de;
            this.state.christopherReviewText = christopherReviewText_de;
            this.state.aliceReviewText = aliceReviewText_de;
            this.state.userReviewsIntro = userReviewsIntro_de;
            this.state.homePageText = homePageText_de;
            this.state.isIOS = true;
            this.state.prefix = '/de'
        }
        if (this.props.language === "DE-CH") {
            this.state.samReviewText = samReviewText_de_ch;
            this.state.rogerReviewText = rogerReviewText_de_ch;
            this.state.amandaReviewText = amandaReviewText_de_ch;
            this.state.christopherReviewText = christopherReviewText_de_ch;
            this.state.aliceReviewText = aliceReviewText_de_ch;
            this.state.userReviewsIntro = userReviewsIntro_de_ch;
            this.state.homePageText = homePageText_de_ch;
            this.state.isIOS = true;
            this.state.prefix = '/de-ch'
        }
        if (this.props.language === "EN-CA") {
            this.state.samReviewText = samReviewText_en;
            this.state.rogerReviewText = rogerReviewText_en;
            this.state.amandaReviewText = amandaReviewText_en;
            this.state.christopherReviewText = christopherReviewText_en;
            this.state.aliceReviewText = aliceReviewText_en;
            this.state.userReviewsIntro = userReviewsIntro_en_ca;
            this.state.homePageText = homePageText_en_ca;
            this.state.isIOS = false;
            this.state.prefix = '/en-ca'
        }
        if (this.props.language === "FR") {
            this.state.samReviewText = samReviewText_fr;
            this.state.rogerReviewText = rogerReviewText_fr;
            this.state.amandaReviewText = amandaReviewText_fr;
            this.state.christopherReviewText = christopherReviewText_fr;
            this.state.aliceReviewText = aliceReviewText_fr;
            this.state.userReviewsIntro = userReviewsIntro_fr;
            this.state.homePageText = homePageText_fr;
            this.state.isIOS = true;
            this.state.prefix = '/fr-ch'
        }

        if (this.props.language === "FR-CA") {
            this.state.samReviewText = samReviewText_fr_ca;
            this.state.rogerReviewText = rogerReviewText_fr_ca;
            this.state.amandaReviewText = amandaReviewText_fr_ca;
            this.state.christopherReviewText = christopherReviewText_fr_ca;
            this.state.aliceReviewText = aliceReviewText_fr_ca;
            this.state.userReviewsIntro = userReviewsIntro_fr_ca;
            this.state.homePageText = homePageText_fr_ca;
            this.state.isIOS = false;
            this.state.prefix = '/fr-ca'
        }

        if (this.props.language === "FR-FR") {
            this.state.samReviewText = samReviewText_fr;
            this.state.rogerReviewText = rogerReviewText_fr;
            this.state.amandaReviewText = amandaReviewText_fr;
            this.state.christopherReviewText = christopherReviewText_fr;
            this.state.aliceReviewText = aliceReviewText_fr;
            this.state.userReviewsIntro = userReviewsIntro_fr;
            this.state.homePageText = homePageText_fr;
            this.state.isIOS = true;
            this.state.prefix = '/fr'
        }

        if (this.props.language === "NL") {
            this.state.samReviewText = samReviewText_nl;
            this.state.rogerReviewText = rogerReviewText_nl;
            this.state.amandaReviewText = amandaReviewText_nl;
            this.state.christopherReviewText = christopherReviewText_nl;
            this.state.aliceReviewText = aliceReviewText_nl;
            this.state.userReviewsIntro = userReviewsIntro_nl;
            this.state.homePageText = homePageText_nl;
            this.state.isIOS = true;
            this.state.prefix = '/nl'
        }
        if (this.props.language === "IT") {
            this.state.samReviewText = samReviewText_it;
            this.state.rogerReviewText = rogerReviewText_it;
            this.state.amandaReviewText = amandaReviewText_it;
            this.state.christopherReviewText = christopherReviewText_it;
            this.state.aliceReviewText = aliceReviewText_it;
            this.state.userReviewsIntro = userReviewsIntro_it;
            this.state.homePageText = homePageText_it;
            this.state.isIOS = true;
            this.state.prefix = '/it'
        }
        if (this.props.language === "IT-CH") {
            this.state.samReviewText = samReviewText_it_ch;
            this.state.rogerReviewText = rogerReviewText_it_ch;
            this.state.amandaReviewText = amandaReviewText_it_ch;
            this.state.christopherReviewText = christopherReviewText_it_ch;
            this.state.aliceReviewText = aliceReviewText_it_ch;
            this.state.userReviewsIntro = userReviewsIntro_it_ch;
            this.state.homePageText = homePageText_it_ch;
            this.state.isIOS = true;
            this.state.prefix = '/it-ch'
        }

        if (this.props.language === "CZ") {
            this.state.samReviewText = samReviewText_cz;
            this.state.rogerReviewText = rogerReviewText_cz;
            this.state.amandaReviewText = amandaReviewText_cz;
            this.state.christopherReviewText = christopherReviewText_cz;
            this.state.aliceReviewText = aliceReviewText_cz;
            this.state.userReviewsIntro = userReviewsIntro_cz;
            this.state.homePageText = homePageText_cz;
            this.state.isIOS = true;
            this.state.prefix = '/cz'
        }
        if (this.props.language === "FI") {
            this.state.samReviewText = samReviewText_fi;
            this.state.rogerReviewText = rogerReviewText_fi;
            this.state.amandaReviewText = amandaReviewText_fi;
            this.state.christopherReviewText = christopherReviewText_fi;
            this.state.aliceReviewText = aliceReviewText_fi;
            this.state.userReviewsIntro = userReviewsIntro_fi;
            this.state.homePageText = homePageText_fi;
            this.state.isIOS = true;
            this.state.prefix = '/fi'
        }
        if (this.props.language === "PL") {
            this.state.samReviewText = samReviewText_pl;
            this.state.rogerReviewText = rogerReviewText_pl;
            this.state.amandaReviewText = amandaReviewText_pl;
            this.state.christopherReviewText = christopherReviewText_pl;
            this.state.aliceReviewText = aliceReviewText_pl;
            this.state.userReviewsIntro = userReviewsIntro_pl;
            this.state.homePageText = homePageText_pl;
            this.state.isIOS = true;
            this.state.prefix = '/pl'
        }
        if (this.props.language === "SE") {
            this.state.samReviewText = samReviewText_se;
            this.state.rogerReviewText = rogerReviewText_se;
            this.state.amandaReviewText = amandaReviewText_se;
            this.state.christopherReviewText = christopherReviewText_se;
            this.state.aliceReviewText = aliceReviewText_se;
            this.state.userReviewsIntro = userReviewsIntro_se;
            this.state.homePageText = homePageText_se;
            this.state.isIOS = true;
            this.state.prefix = '/se'
        }
        if (this.props.language === "NO") {
            this.state.samReviewText = samReviewText_no;
            this.state.rogerReviewText = rogerReviewText_no;
            this.state.amandaReviewText = amandaReviewText_no;
            this.state.christopherReviewText = christopherReviewText_no;
            this.state.aliceReviewText = aliceReviewText_no;
            this.state.userReviewsIntro = userReviewsIntro_no;
            this.state.homePageText = homePageText_no;
            this.state.isIOS = true;
            this.state.prefix = '/nb'
        }
        if (this.props.language === "DK") {
            this.state.samReviewText = samReviewText_dk;
            this.state.rogerReviewText = rogerReviewText_dk;
            this.state.amandaReviewText = amandaReviewText_dk;
            this.state.christopherReviewText = christopherReviewText_dk;
            this.state.aliceReviewText = aliceReviewText_dk;
            this.state.userReviewsIntro = userReviewsIntro_dk;
            this.state.homePageText = homePageText_dk;
            this.state.isIOS = true;
            this.state.prefix = '/dk'
        }
        if (this.props.language === "ES") {
            this.state.samReviewText = samReviewText_es;
            this.state.rogerReviewText = rogerReviewText_es;
            this.state.amandaReviewText = amandaReviewText_es;
            this.state.christopherReviewText = christopherReviewText_es;
            this.state.aliceReviewText = aliceReviewText_es;
            this.state.userReviewsIntro = userReviewsIntro_es;
            this.state.homePageText = homePageText_es;
            this.state.isIOS = true;
            this.state.prefix = '/es'
        }
        if (this.props.language === "PT") {
            this.state.samReviewText = samReviewText_pt;
            this.state.rogerReviewText = rogerReviewText_pt;
            this.state.amandaReviewText = amandaReviewText_pt;
            this.state.christopherReviewText = christopherReviewText_pt;
            this.state.aliceReviewText = aliceReviewText_pt;
            this.state.userReviewsIntro = userReviewsIntro_pt;
            this.state.homePageText = homePageText_pt;
            this.state.isIOS = true;
            this.state.prefix = '/pt'
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_en,
                    rogerReviewText: rogerReviewText_en,
                    amandaReviewText: amandaReviewText_en,
                    christopherReviewText: christopherReviewText_en,
                    aliceReviewText: aliceReviewText_en,
                    userReviewsIntro: userReviewsIntro_en,
                    homePageText: homePageText_en,
                    isIOS: true,
                    prefix: ''
                });
            }
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_de,
                    rogerReviewText: rogerReviewText_de,
                    amandaReviewText: amandaReviewText_de,
                    christopherReviewText: christopherReviewText_de,
                    aliceReviewText: aliceReviewText_de,
                    userReviewsIntro: userReviewsIntro_de,
                    homePageText: homePageText_de,
                    isIOS: true,
                    prefix: '/de'
                });
            } else if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_de_ch,
                    rogerReviewText: rogerReviewText_de_ch,
                    amandaReviewText: amandaReviewText_de_ch,
                    christopherReviewText: christopherReviewText_de_ch,
                    aliceReviewText: aliceReviewText_de_ch,
                    userReviewsIntro: userReviewsIntro_de_ch,
                    homePageText: homePageText_de_ch,
                    isIOS: true,
                    prefix: '/de-ch'
                });
            } else if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_en,
                    rogerReviewText: rogerReviewText_en,
                    amandaReviewText: amandaReviewText_en,
                    christopherReviewText: christopherReviewText_en,
                    aliceReviewText: aliceReviewText_en,
                    userReviewsIntro: userReviewsIntro_en_ca,
                    homePageText: homePageText_en_ca,
                    isIOS: false,
                    prefix: '/en-ca'
                });
            } else if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fr,
                    rogerReviewText: rogerReviewText_fr,
                    amandaReviewText: amandaReviewText_fr,
                    christopherReviewText: christopherReviewText_fr,
                    aliceReviewText: aliceReviewText_fr,
                    userReviewsIntro: userReviewsIntro_fr,
                    homePageText: homePageText_fr,
                    isIOS: true,
                    prefix: '/fr-ch'
                });
            } else if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fr_ca,
                    rogerReviewText: rogerReviewText_fr_ca,
                    amandaReviewText: amandaReviewText_fr_ca,
                    christopherReviewText: christopherReviewText_fr_ca,
                    aliceReviewText: aliceReviewText_fr_ca,
                    userReviewsIntro: userReviewsIntro_fr_ca,
                    homePageText: homePageText_fr_ca,
                    isIOS: false,
                    prefix: '/fr-ca'
                });
            } else if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fr,
                    rogerReviewText: rogerReviewText_fr,
                    amandaReviewText: amandaReviewText_fr,
                    christopherReviewText: christopherReviewText_fr,
                    aliceReviewText: aliceReviewText_fr,
                    userReviewsIntro: userReviewsIntro_fr,
                    homePageText: homePageText_fr,
                    isIOS: true,
                    prefix: '/fr'
                });
            } else if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_nl,
                    rogerReviewText: rogerReviewText_nl,
                    amandaReviewText: amandaReviewText_nl,
                    christopherReviewText: christopherReviewText_nl,
                    aliceReviewText: aliceReviewText_nl,
                    userReviewsIntro: userReviewsIntro_nl,
                    homePageText: homePageText_nl,
                    isIOS: true,
                    prefix: '/nl'
                });
            } else if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_it,
                    rogerReviewText: rogerReviewText_it,
                    amandaReviewText: amandaReviewText_it,
                    christopherReviewText: christopherReviewText_it,
                    aliceReviewText: aliceReviewText_it,
                    userReviewsIntro: userReviewsIntro_it,
                    homePageText: homePageText_it,
                    isIOS: true,
                    prefix: '/it'
                });
            } else if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_it_ch,
                    rogerReviewText: rogerReviewText_it_ch,
                    amandaReviewText: amandaReviewText_it_ch,
                    christopherReviewText: christopherReviewText_it_ch,
                    aliceReviewText: aliceReviewText_it_ch,
                    userReviewsIntro: userReviewsIntro_it_ch,
                    homePageText: homePageText_it_ch,
                    isIOS: true,
                    prefix: '/it-ch'
                });
            } else if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_cz,
                    rogerReviewText: rogerReviewText_cz,
                    amandaReviewText: amandaReviewText_cz,
                    christopherReviewText: christopherReviewText_cz,
                    aliceReviewText: aliceReviewText_cz,
                    userReviewsIntro: userReviewsIntro_cz,
                    homePageText: homePageText_cz,
                    isIOS: true,
                    prefix: '/cz'
                });
            } else if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fi,
                    rogerReviewText: rogerReviewText_fi,
                    amandaReviewText: amandaReviewText_fi,
                    christopherReviewText: christopherReviewText_fi,
                    aliceReviewText: aliceReviewText_fi,
                    userReviewsIntro: userReviewsIntro_fi,
                    homePageText: homePageText_fi,
                    isIOS: true,
                    prefix: '/fi'
                });
            } else if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_pl,
                    rogerReviewText: rogerReviewText_pl,
                    amandaReviewText: amandaReviewText_pl,
                    christopherReviewText: christopherReviewText_pl,
                    aliceReviewText: aliceReviewText_pl,
                    userReviewsIntro: userReviewsIntro_pl,
                    homePageText: homePageText_pl,
                    isIOS: true,
                    prefix: '/pl'
                });
            } else if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_se,
                    rogerReviewText: rogerReviewText_se,
                    amandaReviewText: amandaReviewText_se,
                    christopherReviewText: christopherReviewText_se,
                    aliceReviewText: aliceReviewText_se,
                    userReviewsIntro: userReviewsIntro_se,
                    homePageText: homePageText_se,
                    isIOS: true,
                    prefix: '/se'
                });
            } else if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_no,
                    rogerReviewText: rogerReviewText_no,
                    amandaReviewText: amandaReviewText_no,
                    christopherReviewText: christopherReviewText_no,
                    aliceReviewText: aliceReviewText_no,
                    userReviewsIntro: userReviewsIntro_no,
                    homePageText: homePageText_no,
                    isIOS: true,
                    prefix: '/nb'
                });
            } else if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_dk,
                    rogerReviewText: rogerReviewText_dk,
                    amandaReviewText: amandaReviewText_dk,
                    christopherReviewText: christopherReviewText_dk,
                    aliceReviewText: aliceReviewText_dk,
                    userReviewsIntro: userReviewsIntro_dk,
                    homePageText: homePageText_dk,
                    isIOS: true,
                    prefix: '/dk'
                });
            } else if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_es,
                    rogerReviewText: rogerReviewText_es,
                    amandaReviewText: amandaReviewText_es,
                    christopherReviewText: christopherReviewText_es,
                    aliceReviewText: aliceReviewText_es,
                    userReviewsIntro: userReviewsIntro_es,
                    homePageText: homePageText_es,
                    isIOS: true,
                    prefix: '/es'
                });
            } else if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_pt,
                    rogerReviewText: rogerReviewText_pt,
                    amandaReviewText: amandaReviewText_pt,
                    christopherReviewText: christopherReviewText_pt,
                    aliceReviewText: aliceReviewText_pt,
                    userReviewsIntro: userReviewsIntro_pt,
                    homePageText: homePageText_pt,
                    isIOS: true,
                    prefix: '/pt'
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.videoRef = React.createRef();
        this.sliderRef = React.createRef();
    }

    setOpen = (value) => {
        if (!this.state.isOpen) {
            // ReactGA.pageview("Play_video_" + this.language);
            // ReactGA.send({ hitType: "pageview", page: "/home/video/" + this.language,
            //     title: "Play_video_" + this.language });
        }
        this.setState(
            {
                isOpen: value,
            },
            () => {

                if (this.state.isOpen) {
                    this.videoRef.current.play();
                } else {
                    this.videoRef.current.pause();
                }
                // const element = document.getElementsByTagName('body')[0];
                // if (this.state.isOpen) {
                // 	if (element) {
                // 		element.classList.add('model-open');
                // 	}
                // } else {
                // 	element.classList.remove('model-open');
                // }
            }
        );
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title> {parse(this.state.homePageText.homePageTitle)}</title>
                    <meta name="title" content={parse(this.state.homePageText.homePageTitleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.homePageText.homePageDescriptionMeta)}/>
                    <meta name="keywords" content={this.state.homePageText.keywords}/>
                    <meta property="og:locale" content={this.state.homePageText.localeMeta}/>
                </Helmet>
                <Header props={this.props}/>
                <section className="main-banner">
                    <div className="banner-wrap">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-md-7 col-xl-6 banner-left">
                                    <h1>CamAPS<sup>&reg;</sup> <span>FX</span></h1>
                                    <p>{parse(this.state.homePageText.introPara1)}</p>
                                    {/*{(this.state.language === "EN") &&*/}
                                    {/*<p style={{fontSize:16}}>*/}
                                    {/*    <a*/}
                                    {/*        href="https://www.bbc.co.uk/iplayer/episode/m0011n7r/the-one-show-15112021"*/}
                                    {/*        title="BBC One Show"*/}
                                    {/*        target="_blank" rel="noopener noreferrer">*/}
                                    {/*        As featured on the BBC One Show</a>*/}
                                    {/*    <br />*/}
                                    {/*    Dominic Littlewood, also living with type 1 diabetes, interviews Maebh (aged 5)*/}
                                    {/*    to learn how the CamAPS FX hybrid closed-loop system helps her*/}
                                    {/*    to manage her type 1 diabetes more easily.*/}
                                    {/*</p>}*/}
                                    {(this.state.language === "XXX") &&
                                    <p style={{fontSize: 16}}>
                                        <a
                                            href="https://www.cam.ac.uk/stories/KidsArtificialPancreas"
                                            title="CamAPS FX in very young children"
                                            target="_blank" rel="noopener noreferrer">
                                            Top news: The life-changing artificial pancreas</a>
                                        <br/>
                                        CamAPS FX improves glucose control in very young children
                                        as shown in a study published in a leading medical journal, 20 January 2022.
                                    </p>}
                                    <NavLink to={this.state.prefix + "/faq"}
                                             className="btn">
                                        {parse(this.state.homePageText.findOutMore)}</NavLink>
                                </div>
                                {(this.state.language !== "FR-CA") &&
                                <div className="col-12 col-md-5 col-xl-6 banner-right">
                                    <img src={phone_image} alt=""/>
                                </div>
                                }
                                {(this.state.language === "FR-CA") &&
                                    <div className="col-12 col-md-5 col-xl-6 banner-right">
                                        <img src={phone_image_fr_ca} alt=""/>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <section className='blue-content-box'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-md-6 left__blue__content'>
                                <h2>
                                    <span>{parse(this.state.homePageText.missionHeading)}</span>
                                </h2>
                                <p>
                                    {parse(this.state.homePageText.missionText)}
                                </p>
                            </div>
                            {(this.state.language !== "FR-FR") &&
                            <div className='col-12 col-md-6 popup__wrapper'>
                                <VideoPopup
                                    setOpen={this.setOpen}
                                    isOpen={this.state.isOpen}
                                    videoRef={this.videoRef}
                                    language={this.props.language}
                                />
                                {
                                    !this.state.isOpen &&
                                    <a href="#!" className="video-btn" onClick={(e) => {
                                        e.preventDefault();
                                        this.setOpen(true)
                                    }}><img src={video_ic} alt=""/></a>
                                }
                            </div>}
                        </div>
                    </div>
                </section>
                {isCamAPSLibertyVisible(this.state.language) && (
                    <NavLink
                        to={`${this.state.prefix}/liberty`}
                        className="liberty-home-segment"
                        style={{
                            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${liberty_home_bg})`
                        }}
                    >
                        <div className="liberty-home-segment__content">
                            <img
                                src={liberty_logo_white}
                                alt="CamAPS Liberty"
                                className="liberty-home-segment__logo"
                            />
                            <p className="liberty-home-segment__subhead">
                                {this.state.homePageText.libertyHomeSubhead}
                            </p>
                        </div>
                        <span className="liberty-home-segment__btn">
                            {parse(this.state.homePageText.findOutMore)}
                        </span>
                    </NavLink>
                )}
                <section className="service-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12 service-col">
                                <div className="icon-col">
                                    <span className="col-img"><img src={service_ic} alt="icon"/></span>
                                    <h4>{parse(this.state.homePageText.adaptiveHeading)}</h4>
                                    <p>{parse(this.state.homePageText.adaptiveText)} </p>
                                </div>
                            </div>
                            {(this.state.isIOS !== true) &&
                                <div className="col-12 col-md-6 service-col">
                                    <div className="icon-col">
                                        <span className="col-img"><img src={smartphone_ic} alt="icon"/></span>
                                        <h4>{parse(this.state.homePageText.runsHeading)}</h4>
                                        <p>{parse(this.state.homePageText.runsText)}</p>
                                        <p><small>{parse(this.state.homePageText.runsTextTrademark)}</small></p>
                                    </div>
                                </div>
                            }
                            {(this.state.isIOS === true) &&
                                <div className="col-12 col-md-6 service-col">
                                    <div className="icon-col">
                                        <span className="col-img"><img src={smartphone_ic} alt="icon"/></span>
                                        <h4>{parse(this.state.homePageText.runsHeading)}</h4>
                                        <p>{parse(this.state.homePageText.runsText2)}</p>
                                        <p><small>{parse(this.state.homePageText.runsTextTrademark)}</small></p>
                                    </div>
                                </div>
                            }
                            <div className="col-12 col-md-6 service-col">
                                <div className="icon-col">
                                    <span className="col-img"><img src={family_ic} alt="icon"/></span>
                                    <h4>{parse(this.state.homePageText.allAgesHeading)}</h4>
                                    <p>{parse(this.state.homePageText.allAgesText)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {this.state.homePageText?.pregnancyHomeTitle && (
                    <NavLink
                        to={`${this.state.prefix}/pregnancy`}
                        className="pregnancy-home-segment"
                        style={{
                            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${pregnancy_home_bg})`
                        }}
                    >
                        <div className="container">
                            <div>
                                <h2>{this.state.homePageText?.pregnancyHomeTitle}</h2>
                                <p>{this.state.homePageText?.pregnancyHomeText}</p>
                                <span>{parse(this.state.homePageText?.findOutMore)}</span>
                            </div>
                        </div>
                    </NavLink>
                )}
                {(this.state.language !== "FR-FR") &&
                <section className="single-ic-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-7">
                                <div className="content-left">
                                    <h2>{parse(this.state.homePageText.testedHeading)}</h2>
                                    <p>{parse(this.state.homePageText.testedText_p1)}</p>
                                    <p>{parse(this.state.homePageText.testedText_p2)}</p>
                                    <p>{parse(this.state.homePageText.testedText_p3)}</p>
                                    <ol>
                                        <li><a href="https://doi.org/10.1016/S0140-6736(18)31947-0"
                                               title="">https://doi.org/10.1016/S0140-6736(18)31947-0</a></li>
                                        <li><a href="https://www.nejm.org/doi/10.1056/NEJMoa1509351"
                                               title="">https://doi.org/10.1056/NEJMoa1509351</a></li>
                                        <li><a href="https://www.nejm.org/doi/10.1056/NEJMoa1602494"
                                               title="">https://doi.org/10.1056/NEJMoa1602494</a></li>
                                        <li><a href="https://care.diabetesjournals.org/content/42/4/594.long"
                                               title="">https://doi.org/10.1056/10.2337/dc18-1881</a></li>
                                        <li><a href="https://journals.sagepub.com/doi/full/10.1177/1932296817702656"
                                               title="">https://doi.org/10.1177/1932296817702656</a></li>
                                        <li><a
                                            href="https://diabetes.medicinematters.com/artificial-pancreas-systems/type-1-diabetes/the-artificial-pancreas--what-s-on-the-horizon-/16939360"
                                            title="">https://diabetes.medicinematters.com/artificial-pancreas-systems/type-1-diabetes/the-artificial-pancreas--what-s-on-the-horizon-/16939360</a>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                            <div className="col-12 col-md-5 image-right-wrap">
                                <div className="image-right">
                                    <img src={tested_ic} alt="icon"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>}
                {(this.state.language !== "FR-FR") &&
                <section className='home-review-sec'>
                    {(() => {
                        const reviewSlides = [
                            {
                                image: article_img05,
                                review: this.state.aliceReviewText,
                                path: '/stories/alice-hibbert-davies',
                            },
                            {
                                image: article_img04,
                                review: this.state.christopherReviewText,
                                path: '/stories/christopher-salter',
                            },
                            {
                                image: article_img03,
                                review: this.state.amandaReviewText,
                                path: '/stories/amanda-mclaren',
                            },
                            {
                                image: article_img02,
                                review: this.state.rogerReviewText,
                                path: '/stories/roger',
                            },
                            {
                                image: article_img01,
                                review: this.state.samReviewText,
                                path: '/stories/sam-and-sofia-stevie',
                            },
                        ];
                        return (
                    <>
                    <Slider
                        ref={this.sliderRef}
                        className='home-review-slider'
                        dots={false}
                        arrows={false}
                        infinite={true}
                        speed={550}
                        slidesToShow={1}
                        slidesToScroll={1}
                        autoplay={true}
                        autoplaySpeed={3000}
                        pauseOnHover={true}
                        pauseOnFocus={true}
                        swipe={true}
                        draggable={true}
                        touchMove={true}
                        swipeToSlide={true}
                        centerMode={true}
                        centerPadding='11%'
                        adaptiveHeight={true}
                        responsive={[
                            {
                                breakpoint: 992,
                                settings: {
                                    variableWidth: true,
                                    centerMode: true,
                                    centerPadding: '32px',
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    autoplay: true,
                                    autoplaySpeed: 3000,
                                    swipe: true,
                                    draggable: true,
                                    touchMove: true,
                                    swipeToSlide: true
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    variableWidth: true,
                                    centerMode: true,
                                    centerPadding: '24px',
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    autoplay: true,
                                    autoplaySpeed: 3000,
                                    swipe: true,
                                    draggable: true,
                                    touchMove: true,
                                    swipeToSlide: true
                                }
                            }
                        ]}
                        afterChange={(i) => this.setState({currentSlide: i})}>
                        {reviewSlides.map((slide) => (
                            <div className='hrc-card' key={slide.path}>
                                <div className='hrc-card-inner'>
                                    <div className='hrc-card-left'>
                                        <div className='hrc-vline' aria-hidden='true'></div>
                                        <div className='hrc-avatar-wrap'>
                                            <img
                                                className='hrc-avatar'
                                                src={slide.image}
                                                alt={slide.review.imageTitle}
                                            />
                                        </div>
                                    </div>
                                    <div className='hrc-card-right'>
                                        <p className='hrc-name'>{slide.review.imageTitle}</p>
                                        {parse(slide.review.shortIntroAndBody)}
                                        <NavLink
                                            to={this.state.prefix + slide.path}
                                            className='hrc-readmore'>
                                            {parse(this.state.userReviewsIntro.readMore)}
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                    <div className='container hrc-action-wrap'>
                        <div className='hrc-action'>
                            <NavLink className='btn hrc-more-btn'
                                     to={this.state.prefix + '/stories'}>
                                {parse(this.state.userReviewsIntro.linkMoreReviews)}
                            </NavLink>
                        </div>
                    </div>
                    <div className='hrc-dots'>
                        {reviewSlides.map((_, i) => (
                            <button
                                key={i}
                                type='button'
                                className={`hrc-dot${this.state.currentSlide === i ? ' hrc-dot--active' : ''}`}
                                aria-label={`Slide ${i + 1}`}
                                onClick={() => {
                                    this.sliderRef.current.slickGoTo(i);
                                    this.setState({currentSlide: i});
                                }}>
                            </button>
                        ))}
                    </div>
                    </>
                        );
                    })()}
                </section>}
                <section className='content-sec'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-sm-12'>
                                <div className='content-inner'>
                                    <h2>{parse(this.state.homePageText.whatIsFXheading)}</h2>
                                    <p>{parse(this.state.homePageText.whatIsFXtext)}</p>
                                    <NavLink to={this.state.prefix + "/faq"}
                                             className="btn">
                                        {parse(this.state.homePageText.findOutMore)}</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {false && (this.state.language !== 'EN-CA') && (this.state.language !== 'FR-CA') &&
                <section className="two-col-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-12">
                                <h2>{parse(homePageText_en.pressReleaseTitle)}</h2>
                            </div>
                            <div className="col-12 col-md-7">
                                <div className="left-col">
                                    {/*<div className="right-content">*/}
                                    {/*    <h5>20 March 2020</h5>*/}
                                    {/*    <h3>CE marking and UK launch</h3>*/}
                                    {/*    <p>World’s first artificial pancreas app licensed for people with*/}
                                    {/*        type 1 diabetes in the UK and EU.</p>*/}
                                    {/*    <a href="https://s3-eu-west-1.amazonaws.com/admin.camdiab.com/press.release/Press+release+-+launch+16+March+2020.pdf"*/}
                                    {/*       title="Download" className="download-link"><img src={down_arrow}*/}
                                    {/*                                                       alt="ic"/>Download</a>*/}
                                    {/*</div>*/}
                                    {(this.state.language === "EN") &&
                                        <div className="right-content">
                                            <h5>{parse(homePageText_en.dateCanadaIOSPressRelease)}</h5>
                                            <h3>{parse(homePageText_en.headingCanadaIOSPressRelease)}</h3>
                                            <p>{parse(homePageText_en.textCanadaIOSPressRelease)}</p>
                                            <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/Press-release_Canada_iOS_FSL3.pdf"
                                               title="Download" className="download-link"><img src={down_arrow}
                                                                                               alt="ic"/>Download</a>
                                            <p>&nbsp;</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="ic-image">
                                            <img src={file_ic} alt="ic"/>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="right-content">
                                            <h5>{parse(homePageText_en.dateInitialLibertyIOSPressRelease)}</h5>
                                            <h3>{parse(homePageText_en.headingInitialLibertyIOSPressRelease)}</h3>
                                            <p>{parse(homePageText_en.textInitialLibertyIOSPressRelease)}</p>
                                            <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/press-release-fully-closed-loop-approval-20260108.pdf"
                                               title="Download" className="download-link"><img src={down_arrow}
                                                                                               alt="ic"/>Download</a>
                                            <p>&nbsp;</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="ic-image">
                                            <img src={file_ic} alt="ic"/>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="right-content">
                                            <h5>{parse(homePageText_en.dateCompanionIOSPressRelease)}</h5>
                                            <h3>{parse(homePageText_en.headingCompanionIOSPressRelease)}</h3>
                                            <p>{parse(homePageText_en.textCompanionIOSPressRelease)}</p>
                                            <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/PRESS_RELEASE_CamDiab_Announce_iPhone_Companion.pdf"
                                               title="Download" className="download-link"><img src={down_arrow}
                                                                                               alt="ic"/>Download</a>
                                            <p>&nbsp;</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="ic-image">
                                            <img src={file_ic} alt="ic"/>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="right-content">
                                            <h5>{parse(homePageText_en.dateIOSPressReleaseWave2)}</h5>
                                            <h3>{parse(homePageText_en.headingIOSPressReleaseWave2)}</h3>
                                            <p>{parse(homePageText_en.textIOSPressReleaseWave2)}</p>
                                            <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/250610__Ypsomed_Press_Release_iOS_wave2_final.pdf"
                                               title="Download" className="download-link"><img src={down_arrow}
                                                                                               alt="ic"/>Download</a>
                                            <p>&nbsp;</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="ic-image">
                                            <img src={file_ic} alt="ic"/>
                                        </div>
                                    }
                                    {(this.state.language === "EN") &&
                                        <div className="right-content">
                                            <h5>{parse(homePageText_en.dateIOSPressReleaseUK)}</h5>
                                            <h3>{parse(homePageText_en.headingIOSPressReleaseUK)}</h3>
                                            <p>{parse(homePageText_en.textIOSPressReleaseUK)}</p>
                                            <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamAPS_FX_iOS_press_release_UK.pdf"
                                               title="Download" className="download-link"><img src={down_arrow}
                                                                                               alt="ic"/>Download</a>
                                            <p>&nbsp;</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    }
                                    <div className="ic-image">
                                        <img src={file_ic} alt="ic"/>
                                    </div>
                                    <div className="right-content">
                                        <h5>{parse(this.state.homePageText.dateIOSPressRelease)}</h5>
                                        <h3>{parse(this.state.homePageText.headingIOSPressRelease)}</h3>
                                        <p>{parse(this.state.homePageText.textIOSPressRelease)}</p>
                                        <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamAPS_FX_iOS_press_release.pdf"
                                           title="Download" className="download-link"><img src={down_arrow}
                                                                                           alt="ic"/>Download</a>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                    </div>
                                    <div className="ic-image">
                                        <img src={file_ic} alt="ic"/>
                                    </div>
                                    <div className="right-content">
                                        <h5>{parse(this.state.homePageText.dateFDAPressRelease)}</h5>
                                        <h3>{parse(this.state.homePageText.headingFDAPressRelease)}</h3>
                                        <p>{parse(this.state.homePageText.textFDAPressRelease)}</p>
                                        <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamDiab+secures+FDA+approval+for+advanced+adaptive+hybrid+closed-loop+app+CamAPS+FX.pdf"
                                           title="Download" className="download-link"><img src={down_arrow}
                                                                                           alt="ic"/>Download</a>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                    </div>
                                    <div className="ic-image">
                                        <img src={file_ic} alt="ic"/>
                                    </div>
                                    <div className="right-content">
                                        <h5>{parse(this.state.homePageText.dateLibrePressRelease)}</h5>
                                        <h3>{parse(this.state.homePageText.headingLibrePressRelease)}</h3>
                                        <p>{parse(this.state.homePageText.textLibrePressRelease)}</p>
                                        <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/221125_Ypsomed_PressRelease_FreeStyle_Libre3_final (003).pdf"
                                           title="Download" className="download-link"><img src={down_arrow}
                                                                                           alt="ic"/>Download</a>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                    </div>
                                    <div className="ic-image">
                                        <img src={file_ic} alt="ic"/>
                                    </div>
                                    <div className="right-content">
                                        <h5>{parse(this.state.homePageText.dateAdcPressRelease)}</h5>
                                        <h3>{parse(this.state.homePageText.headingAdcPressRelease)}</h3>
                                        <p>{parse(this.state.homePageText.textAdcPressRelease)}</p>
                                        <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/ADC_CamDiab_Ypsomed_Joint_Press_Release_4.24.22.pdf"
                                           title="Download" className="download-link"><img src={down_arrow}
                                                                                           alt="ic"/>Download</a>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                    </div>
                                    <div className="ic-image">
                                        <img src={file_ic} alt="ic"/>
                                    </div>
                                    <div className="right-content">
                                        <h5>{parse(this.state.homePageText.dateYpsoPressRelease)}</h5>
                                        <h3>{parse(this.state.homePageText.headingYpsoPressRelease)}</h3>
                                        <p>{parse(this.state.homePageText.textYpsoPressRelease)}</p>
                                        <a href="https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/220322_Media_release_EN_final+Ypsomed.pdf"
                                           title="Download" className="download-link"><img src={down_arrow}
                                                                                           alt="ic"/>Download</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-5">
                                <SimpleBar className="custom-scrollbar" forceVisible="y" autoHide="false">
                                    <div className="right-col">
                                        {/*<h5>Date tag</h5>*/}
                                        {/*<p>Title of previous press release</p>*/}
                                        {/*<a href="/#" title="Download" className="download-link"><img src={down_arrow} alt="ic" />Download</a>*/}
                                        {/*<h5>Date tag</h5>*/}
                                        {/*<p>Title of previous press release</p>*/}
                                        {/*<a href="/#" title="Download" className="download-link"><img src={down_arrow} alt="ic" />Download</a>*/}
                                        {/*<h5>Date tag</h5>*/}
                                        {/*<p>Title of previous press release</p>*/}
                                        {/*<a href="/#" title="Download" className="download-link"><img src={down_arrow} alt="ic" />Download</a>*/}
                                        {/*<h5>Date tag</h5>*/}
                                        {/*<p>Title of previous press release</p>*/}
                                        {/*<a href="/#" title="Download" className="download-link"><img src={down_arrow} alt="ic" />Download</a>*/}
                                        {/*<h5>Date tag</h5>*/}
                                        {/*<p>Title of previous press release</p>*/}
                                        {/*<a href="/#" title="Download" className="download-link"><img src={down_arrow} alt="ic" />Download</a>*/}
                                        {/*<h5>Date tag</h5>*/}
                                        {/*<p>Title of previous press release</p>*/}
                                        {/*<a href="/#" title="Download" className="download-link"><img src={down_arrow} alt="ic" />Download</a>*/}
                                    </div>
                                </SimpleBar>
                            </div>
                        </div>
                    </div>
                </section>
                }
                <Footer props={this.props}/>
            </div>
        );
    }
}

const VideoPopup = (props) => {
    return (
        <>
            <div

                className='popup-img'>
                <video
                    preload='auto'
                    playsInline={true}
                    ref={props.videoRef}
                    controls
                    poster={popup_img}
                    type='video/mp4'
                    onPlay={(e) => {
                        e.preventDefault();
                        props.setOpen(true)
                    }}
                    onPause={(e) => {
                        e.preventDefault();
                        props.setOpen(false)
                    }}
                    src={
                        (props.language === "DE" || props.language === "DE-CH") ? `${process.env.PUBLIC_URL}/video/video_10_de.mp4` :
                            (props.language === "FR") || (props.language === "FR-FR") ? `${process.env.PUBLIC_URL}/video/video_10_fr.mp4` :
                                (props.language === "CZ") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_cs.mp4` :
                                    (props.language === "DK") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_da.mp4` :
                                        (props.language === "ES") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_es.mp4` :
                                            (props.language === "FI") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_fi.mp4` :
                                                (props.language === "IT" || props.language === "IT-CH") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_it.mp4` :
                                                    (props.language === "NL") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_nl.mp4` :
                                                        (props.language === "PL") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_pl.mp4` :
                                                            (props.language === "SE") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_sv.mp4` :
                                                                (props.language === "NO") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_no.mp4` :
                                                                    (props.language === "EN-CA") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_en_ca.mp4` :
                                                                        (props.language === "FR-CA") ? `${process.env.PUBLIC_URL}/video/video_our_mission_subtitles_fr_ca.mp4` :
                                                                            `${process.env.PUBLIC_URL}/video/video_10.mp4`}
                >
                </video>
            </div>


            {/* <TransitionsModal open={props.isOpen} handleClose={props.setOpen}>
				<LazyLoad>
					<div className='popup__wrapper1'>
						<div className='modal-video1'>
							<div className='close-btn' onClick={props.setOpen}>
								X
							</div>
							<video controls autoPlay>
								<source
									src={`${process.env.PUBLIC_URL}/video/video_10.mp4`}
									type='video/mp4'
								/>
							</video>
						</div>
					</div>
				</LazyLoad>
			</TransitionsModal> */}
        </>
    );
};
